export default __webpack_public_path__ + "static/media/fjarrtolkning3.00bd6b1f.png";